<template>
  <div id="app-nav">
    <div class="nav-top">
      <ul>
        <template v-for="item in navList">
          <li
            v-if="item.data"
            :class="{active:liStyle === item.dict_id}"
            @click="getStyle(item)"
          >{{item.dict_name}}</li>
        </template>
        <li
          v-if="projectData.project_id > 0"
          @click="getMediaList()"
          :class="{active:liStyle === 'media'}"
        >媒体报道</li>
      </ul>
    </div>
    <div v-if="projectData.year && projectData.year.length > 0" style="padding:20px;width:1030px;">
      <div class="nav-box">
        <ul>
          <span class="iconfont">&#xe643;</span>
          <i class="iconfont">&#xe640;</i>
          <li
            v-for="(item,index) in projectData.year"
            :key="index"
            :class="{active:timeStatus==index}"
            @click="changeYear(item,index)"
          >{{item}}</li>
        </ul>
      </div>

      <details-content
        :data="contentData"
        v-if="contentData && contentData.length > 0 && liStyle != 'media'"
        :type="info_type"
        :title="info_title"
      ></details-content>
      <div v-if="liStyle === 'media' && projectData.project_id > 0">
        <WtDataTable
          ref="tables"
          :listUrl="$db.config.projectMediaList"
          :urlParams="{id:id,year:year}"
        >
          <template slot="columns">
            <el-table-column label="报道标题" align="center" min-width="150" prop="title">
              <template slot-scope="scope">
                <a
                  :href="scope.row.url"
                  target="_blank"
                  v-if="scope.row.url"
                  style="text-decoration:underline"
                  :title="'点击跳转'+scope.row.url"
                >{{scope.row.title}}</a>
                <span v-else>{{scope.row.title}}</span>
              </template>
            </el-table-column>
            <el-table-column label="报道级别" align="center" prop="level_text" width="140"></el-table-column>
            <el-table-column label="报道时间" align="center" prop="addtime" width="140"></el-table-column>
            <el-table-column label="报道图片" align="center" prop="url" width="350">
              <template slot-scope="scope">
                <viewer :images="scope.row.pic_url" v-if="scope.row.pic_url.length>0">
                  <img
                    v-for="(val,key) in scope.row.pic_url"
                    :src="val.url"
                    :key="scope.$index+'img'+key"
                    style="width: 35px; height: 35px;cursor: pointer;margin-right:5px"
                  />
                </viewer>
                <span v-else>暂无图片~</span>
              </template>
            </el-table-column>
          </template>
        </WtDataTable>
      </div>
    </div>
    <div v-else>项目内容信息数据更新中~</div>
  </div>
</template>
<script>
import detailsContent from "./details_content";
export default {
  components: {
    detailsContent
  },

  props: {
    projectData: {
      type: Object,
      defalut: () => {}
    }
  },

  data() {
    return {
      contentData: [],
      timeStatus: 0,
      navList: [],
      liStyle: null,
      info_type: null, //内容类别
      info_title: null,
      year: null, //
      mediaList: [] //媒体报道列表
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  watch: {
    projectData: function() {
      if (this.projectData.year && this.projectData.year.length > 0) {
        this.changeYear(this.projectData.year[0]);
      }
    }
  },
  methods: {
    getStyle(item) {
      this.info_type = item.info_type;
      if (item.data && item.data.length > 0) {
        this.contentData = item.data;
      } else {
        this.contentData = [];
      }
      this.liStyle = item.dict_id;
      this.info_title = item.dict_name;
    },
    //获取媒体报道
    getMediaList(page = 1) {
      this.liStyle = "media";
    },
    //获取tab内容
    getContentData(year) {
      this.$db
        .post(this.$db.config.getProjectByYear, { id: this.id, year: year })
        .then(res => {
          if (res && res.code == 200) {
            let arr = [];

            res.data.dict.forEach(item => {
              item.info_type = "dict";
              if (item.hasOwnProperty("data")) {
                arr.push(item);
              }
            });

            //绑定了项目
            if (this.projectData.project_id > 0) {
              //  项目进展
              if (res.data.progress && res.data.progress.length > 0) {
                let temp = {
                  dict_name: "项目进展",
                  dict_id: "progress",
                  info_type: "progress",
                  data: res.data.progress
                };
                arr.push(temp);
              }

              //项目捐赠数据
              if (res.data.donation && res.data.donation.length > 0) {
                let temp = {
                  dict_name: "捐赠信息",
                  dict_id: "donation",
                  info_type: "donation",
                  data: res.data.donation
                };
                arr.push(temp);
              }
            }

            this.navList = arr;

            if (this.navList && this.navList.length > 0) {
              this.getStyle(this.navList[0]);
            }
          }
        });
    },
    changeYear(item, id = 0) {
      this.timeStatus = id;
      this.year = item;
      this.getContentData(item);
    }
  }
};
</script>

<style lang="scss" scoped>
#app-nav {
  width: 1200px;
  margin-bottom: 52px;
  position: relative;
  border: solid 1px #eaeaea;
  min-height: 300px;
  padding-top: 80px;
  display: flex;
}
.nav-box {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f8f8f8;
  border-bottom: solid 1px #eaeaea;
  width: 100%;
  height: 80px;
  > ul {
    margin: 22px 0;
    display: flex;
    flex-wrap: wrap;
    padding-left: 38px;
    position: relative;
    > li {
      padding: 0 18px;
      height: 33px;
      background-color: #ffffff;
      border-radius: 18px;
      border: solid 1px #cccccc;
      line-height: 33px;
      color: #999999;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        border-color: #c30d23;
        color: #c30d23;
      }
    }
    > i {
      font-style: normal;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      color: #ccc;
      font-size: 14px;
    }
    > span {
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
      color: #ccc;
      font-size: 14px;
    }
  }
}
.nav-top {
  height: 100%;
  background-color: #f8f8f8;
  border-right: solid 1px #eaeaea;
  border-left: none;
  > ul {
    width: 130;
    background-color: #fff;
    > li {
      list-style: none;
      width: 130px;
      border-bottom: solid 1px #eaeaea;
      border-left: none;
      line-height: 54px;
      text-align: center;
      background-color: #fff;
      font-size: 16px;
      color: #333;
      border-right: none;
      cursor: pointer;
      &:first-child {
        border-left: solid 1px #eaeaea;
      }
      &.active {
        border-left: 3px solid #c30d23;
        color: #c30d23;
      }
    }
  }
}
.content-box {
  padding: 50px 100px 45px 36px;
  > p {
    color: #666666;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  > img {
    width: 576px;
    height: 384px;
    margin: 0 129px 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project_details/details_nav.vue